import axios from '@axios'

export const state = {
  clearances: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allClearances: (state) => state.clearances,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_CLEARANCES: (state, resp) => {
    if (!resp) return null
    state.clearances = resp.clearances
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_CLEARANCE: (state, clearance) => {
    state.clearances = state.clearances.filter((w) => w.id !== clearance.id)
  },
}

export const actions = {
  async getClearances({ commit }, params = {}) {
    await axios
      .get('/api/clearances', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_CLEARANCES', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_CLEARANCES',
          err.response.status === 404 ? { clearances: [] } : null
        )
      })
  },
  async createClearance({ commit }, clearance) {
    return axios.post(`/api/clearances`, clearance)
  },
  async editClearance({ commit }, clearance) {
    return axios.put(`/api/clearances`, clearance)
  },
  async deleteClearance({ commit }, clearance) {
    await axios.delete(`/api/clearances/${clearance.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_CLEARANCE', clearance)
      }
    })
  },
}
